import _ from 'lodash'
import API from '../../core/api'
import B_TV_SEARCH_CONFIG from './config'

class BusinessTvSearchClass {
    constructor() {
        this.DOM = {
            form: B_TV_SEARCH_CONFIG.form
        }

        this.endpoint = B_TV_SEARCH_CONFIG.endpoint
        this.DOM.form ? this.init() : null
    }

    init() {
        this._listeners()
    }

    _listeners() {
        this.DOM.form.addEventListener( 'submit', this._submit.bind( this ) )
    }

    _submit() {
        event.preventDefault()

        API.post( this.endpoint, 
            new FormData( this.DOM.form )
        )
        .then( ( response ) => {
            window.location.replace( response.data.redirect )
        })
        .catch( ( err ) => {
            console.log( err )
        })
    }


}

const B_TV_SEARCH = new BusinessTvSearchClass()
export default B_TV_SEARCH